export default __webpack_public_path__ + "static/img44v-f836672b6c9c5782224fda28016e9b91.jpg";